/**
 * File: apps/qbench-cp/reactapp/src/shared/hooks/misc/useDisclosure.js
 *
 * Purpose: Provides open/close/toggle state management for modals, dropdowns, and similar
 *     disclosure UI.
 *
 * Scope: generic open-state UI components across the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Wraps a boolean isOpen state and exposes onOpen, onClose, and onToggle handlers,
 *     returning them alongside the current state as a tuple.
 *
 * Exports: default useDisclosure hook.
 */

import { useState } from 'react';

/**
 * `useDisclosure` helps handle common open, close, or toggle scenarios.
 */
export default function useDisclosure(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onToggle = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return [
    isOpen,
    {
      onOpen,
      onClose,
      onToggle,
    },
  ];
}
